module.exports = __webpack_public_path__ + "static/8-897904cc253ba24f03f587c9e54b1ed3.jpg";